<template lang="html">
  <div class="surgos">
    <h1 class="title">Orvosi ellátásra van szükségük, kérjük, támogasd őket!</h1>
    <AnimalList :animals="animalsNeedHelp" />
  </div>
</template>

<script>
import AnimalList from '@/components/AnimalList.vue'
export default {
  data(){
    return {
      animalsNeedHelp: this.$store.getters.allAnimals.filter(a=>a.colorcode==='pink'),
    }
  },
  components:{
    AnimalList,
  }
}
</script>

<style lang="scss" scoped>
</style>
